<loren-page-content>
  <div class="loren-automation-plan-all-header">
    <mat-card-title [tourAnchor]="mainAnchorId">
      {{ "toolbar.automation_plans" | transloco }}
    </mat-card-title>
    <div [tourAnchor]="createPlanAnchorId">
        <button
                matButton="filled"
                class="btn-green"
                *lorenShowForPrivileges="[privileges.WRITE_AUTOMATION_RULES]"
                (click)="showCreateEditPlanForm(null)">
            {{ "automation_plans.add_plan" | transloco }}
        </button>
    </div>
  </div>
  <div class="loren-automation-plan-all-search">
    @if(searchShown()) {
    <mat-form-field
      class="loren-automation-plan-all-search-field loren-form-field">
      <mat-label>{{ "operations.search" | transloco }}</mat-label>
      <input
        #searchInput
        matInput
        type="text"
        [(ngModel)]="searchValue"
        (keyup)="handleSearch()" />
      @if(searchInput.value) {
      <button
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>

      }
    </mat-form-field>
    } @if(!searchShown()) {
    <button matButton="filled" (click)="showSearch()">
      <mat-icon>search</mat-icon>
      {{ "operations.search" | transloco }}
    </button>
    } @if(searchShown()) {
    <button matButton="filled" class="btn-secondary" (click)="hideSearch()">
      <mat-icon class="mr-1">search_off</mat-icon>
      {{ "operations.hide_search" | transloco }}
    </button>
    }
  </div>
  @if(anyError()) {
  <span style="color: red; font-size: 12px">
    {{ "error_page.automation_plans_error" | transloco }}
  </span>
  } @else {@if (entities?.length) { @if(isHandset) { @for(el of
  tableEntitiesSignal(); track el) {
  <div class="loren-table-mobile">
    <div class="loren-table-mobile-header">
      <span class="loren-automation-plan-all-mobile-title">{{
        el.name | transloco
      }}</span>
      @if(el.isEditable) {
      <mat-icon
        *lorenShowForPrivileges="[privileges.WRITE_AUTOMATION_RULES]"
        class="loren-automation-plan-all-edit"
        [matTooltip]="'Редактирайте ' + el.name"
        (click)="showCreateEditPlanForm(el.item)"
        >edit</mat-icon
      >
      }
    </div>
    <div class="loren-table-mobile-content">
      <span class="loren-table-mobile-content--key">{{
        "automation_plans_table.conditions" | transloco
      }}</span>
      <span>{{ el.conditions }}</span>
      <span class="loren-table-mobile-content--key">{{
        "automation_plans_table.actions" | transloco
      }}</span>
      <span>{{ el.actions }}</span>
      <span class="loren-table-mobile-content--key">{{
        "automation_plans_table.period" | transloco
      }}</span>
      <span>{{ el.period.timePeriod }}</span>
      <span class="loren-table-mobile-content--key">{{
        "automation_plans_table.type" | transloco
      }}</span>
      <span>{{
        (el.isCompanyLevel
          ? "automation_plans_form.company_rule"
          : "automation_plans_form.personal_rule"
        ) | transloco
      }}</span>
      <span class="loren-table-mobile-content--key">{{
        "automation_plans_table.status" | transloco
      }}</span>
      <mat-slide-toggle
        [checked]="el.status"
        [disabled]="!el.isEditable"
        (toggleChange)="toggleElementStatus(el.id)"
        [matTooltip]="'tooltips.toggle_rule' | transloco">
      </mat-slide-toggle>
    </div>
  </div>
  } } @else {
  <table
    mat-table
    [dataSource]="tableEntitiesSignal()"
    class="loren-automation-plan-all-table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ "automation_plans_table.name" | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="conditions">
      <th mat-header-cell *matHeaderCellDef>
        {{ "automation_plans_table.conditions" | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.conditions }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        {{ "automation_plans_table.actions" | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.actions }}</td>
    </ng-container>

    <ng-container matColumnDef="period">
      <th mat-header-cell *matHeaderCellDef>
        {{ "automation_plans_table.period" | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <p class="loren-automation-plan-all-time">{{ element.period.days }}</p>
        <p class="loren-automation-plan-all-time">
          {{ element.period.timePeriod }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>
        {{ "automation_plans_table.type" | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{
          (element.isCompanyLevel
            ? "automation_plans_form.company_rule"
            : "automation_plans_form.personal_rule"
          ) | transloco
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        {{ "automation_plans_table.status" | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [checked]="element.status"
          [disabled]="!element.isEditable"
          (toggleChange)="toggleElementStatus(element.id)"
          [matTooltip]="'tooltips.toggle_rule' | transloco">
        </mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if(element.isEditable) {
        <mat-icon
          *lorenShowForPrivileges="[privileges.WRITE_AUTOMATION_RULES]"
          class="loren-automation-plan-all-edit"
          [matTooltip]="'Редактирайте ' + element.name"
          (click)="showCreateEditPlanForm(element.item)"
          >edit</mat-icon
        >
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  } } @else {
  <mat-card class="loren-automation-plan-none">
    <mat-icon svgIcon="no_data"></mat-icon>
    <p>{{ "automation_plans_table.no_plans" | transloco }}</p>
  </mat-card>
  }}
</loren-page-content>

@if (createEditPlanForm()) {
    <loren-automation-plan-define (ruleSubmitted)="hideCreateEditPlanForm()" />
}
